import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

const application = Application.start();
const context = require.context("promo_emails_controllers", true, /_controller\.(coffee|js)$/);
application.load(definitionsFromContext(context));